module.exports = __webpack_public_path__ + "components/app-promo/static/logo-intersport-128b34194f4d46634407468749c5b75c.svg";